import { AirplanemodeActive, Search, Assessment, KeyboardReturn, AccountTree, AirlineSeatReclineNormal, Games, MergeType } from '@material-ui/icons';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';
import AlarmOnIcon from '@material-ui/icons/AlarmOn';
import TransferWithinAStationIcon from '@material-ui/icons/TransferWithinAStation';
import FindReplaceIcon from '@material-ui/icons/FindReplace';
import CloudCircleIcon from '@material-ui/icons/CloudCircle';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import HowToVoteIcon from '@material-ui/icons/HowToVote';
import {
    handleEditOrderModal, 
    handleEditDriverModal, 
    handleParcelReturnModal, 
    handleSecondDelivery, 
    handleTransferOrdersSubBatch, 
    handleBlockingPackages, 
    handleDriverDispatch, 
    handleComplaint, 
    handleUpdateToolbox, 
    handleQuickTransfer, 
    handleRouteToolbar, 
    handleSelectBatchModal, 
    handleOpenAdvancedSearchDialog,
    handleOpenWorkflowDialog
} from '../../../reducers/uiSlice';
import UsbIcon from '@material-ui/icons/Usb';

const iconStyle = {
    fontSize: 32, 
    margin: 12
}

/*
    *** This is the structure for the menu object ***
    id: unique identifier
    link(optional): link to be opened when clicking on the button (when link is available, dispatchFunction will be disabled)
    dispatchFunction(optional): any dispatch functions can be passed down then be dispatched in toolbarmenu
    icon: icon of the button
    title: title text of the button (translations are automatically done)
    disabled: if button should be disabled
    password_protection: boolean, to determine if content is locked behind password
    access_ability_id: number, the access id that shows/hides the menu item
*/

export const mainMenuItems = [
    {
        id:"menu-select-batch",
        dispatchFunction: handleSelectBatchModal(true),
        icon: <AirplanemodeActive style={iconStyle}/>,
        title: 'select_batches',
        access_ability_id: 1
    },{
        id:"menu-route-tool",
        dispatchFunction: handleRouteToolbar(true),
        icon: <AccountTree style={iconStyle}/>,
        title: 'route_planner',
        access_ability_id: 2
    },{
        id:"menu-edit-order",
        dispatchFunction: handleEditOrderModal({open: true}),
        icon: <Assessment style={iconStyle}/>,
        title: 'edit_order',
        access_ability_id: 3
    },{
        id:"menu-edit-driver",
        dispatchFunction: handleEditDriverModal(true),
        icon: <AirlineSeatReclineNormal style={iconStyle}/>,
        title: 'edit_driver',
        access_ability_id: 4
    },{
        id:"menu-advanced-search",
        dispatchFunction: handleOpenAdvancedSearchDialog(true),
        icon: <Search style={iconStyle}/>,
        title: 'advanced_search',
        access_ability_id: 5
    },{
        id:"menu-batch-management",
        link: "/batch-management",
        icon: <DeviceHubIcon style={iconStyle}/>,
        title: 'batch_management',
        access_ability_id: 6
    },{
        id:"menu-second-delivery",
        dispatchFunction: handleSecondDelivery(true),
        icon: <DepartureBoardIcon style={iconStyle}/>,
        title: 'second_delivery',
        access_ability_id: 7
    },{
        id:"menu-resend-orders",
        link: "/resend-order-management",
        icon: <AlarmOnIcon style={iconStyle}/>,
        title: 'resend_orders',
        access_ability_id: 8
    },{
        id:"menu-parcel-return",
        dispatchFunction: handleParcelReturnModal(true),
        icon: <KeyboardReturn style={iconStyle}/>,
        title: 'parcel_return',
        access_ability_id: 9
    },{
        id:"menu-quick-transfer",
        dispatchFunction: handleQuickTransfer(true),
        icon: <TransferWithinAStationIcon style={iconStyle}/>,
        title: 'quick_transfer',
        access_ability_id: 10
    },{
        id:"menu-driver-dispatch",
        dispatchFunction: handleDriverDispatch(true),
        icon: <DriveEtaIcon style={iconStyle}/>,
        title: 'driver_dispatch',
        access_ability_id: 11
    },{
        id:"menu-holding-packages",
        dispatchFunction: handleBlockingPackages(true),
        icon: <CloudCircleIcon style={iconStyle}/>,
        title: 'holding_packages',
        access_ability_id: 12
    },{
        id:"menu-transfer-sub-batch",
        dispatchFunction: handleTransferOrdersSubBatch(true),
        icon: <FindReplaceIcon style={iconStyle}/>,
        title: 'transfer_orders_sub_batch',
        access_ability_id: 13
    },{
        id:"menu-complaint",
        dispatchFunction: handleComplaint(true),
        icon: <HowToVoteIcon style={iconStyle}/>,
        title: 'complaint',
        access_ability_id: 14
    },{
        id:"menu-update-toolbox",
        dispatchFunction: handleUpdateToolbox(true),
        icon: <Games style={iconStyle}/>,
        title: 'update_toolbox',
        access_ability_id: 15
    },{
        id:"menu-workflow",
        dispatchFunction: handleOpenWorkflowDialog(true),
        icon: <MergeType style={iconStyle}/>,
        title: 'workflow_management',
        access_ability_id: 16
    }, {
        id: "sorting-machine-management",
        link: "/sorting-machine-management",
        icon: <UsbIcon style={iconStyle} />,
        title: 'sorting_machine_management',
        access_ability_id: 42
    }
]